import i18n from "i18n";
import { AUTHENTICATION_LINK_TITLE, SYSTEM_DROPDOWN_TITLE } from "components/navigation/bindings";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ModelProvidersPage from "ai-management/model-providers/ModelProvidersPage";
import CreateModelProviderPage from "ai-management/model-providers/CreateModelProviderPage";
import EditModelProviderPage from "ai-management/model-providers/EditModelProviderPage";
import TokenUsagePage from "ai-management/token-usage/TokenUsagePage";
import {
  MODEL_PROVIDER_TITLE,
  PAGE_NAVIGATION_TITLE,
  TOKEN_USAGE_TITLE,
  FEATURE_MODELS_TITLE
} from "ai-management/AIManagementPageNavigation";
import { AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG, MODEL_PROVIDER_ENTITY_KEY } from "ai-management/Constants";
import { AGENT_WORKFLOW_FEATURE_FLAG } from "aiagent/Constants";
import withAgentWorkflowsLicense from "aiagent/components/withAgentWorkflowsLicense";
import useAgentWorkflowsLicensed from "aiagent/hooks/useAgentWorkflowsLicensed";
import FeatureModelsPage from "ai-management/feature-models/FeatureModelsPage";
import AIManagementRoutes from "./Routes";
const pluginExports = {
  routes: [
    {
      path: AIManagementRoutes.unqualified.MODEL_PROVIDERS,
      component: withAgentWorkflowsLicense(ModelProvidersPage),
      permissions: ["llm_provider:edit"],
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AIManagementRoutes.unqualified.MODEL_PROVIDER_CREATE,
      component: withAgentWorkflowsLicense(CreateModelProviderPage),
      permissions: ["llm_provider:edit"],
      requiredFeatureFlag: AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG
    },
    {
      path: AIManagementRoutes.unqualified.FEATURE_MODELS,
      component: withAgentWorkflowsLicense(FeatureModelsPage),
      permissions: ["llm_provider:edit"],
      requiredFeatureFlag: AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG
    },
    {
      path: AIManagementRoutes.unqualified.modelProviderEdit(":providerId"),
      component: withAgentWorkflowsLicense(EditModelProviderPage),
      permissions: ["llm_provider:edit"],
      requiredFeatureFlag: AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG
    },
    {
      path: AIManagementRoutes.unqualified.TOKEN_USAGE,
      component: withAgentWorkflowsLicense(TokenUsagePage),
      permissions: ["llm_provider:edit"],
      requiredFeatureFlag: AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG
    }
  ],
  entityCreators: [
    {
      id: MODEL_PROVIDER_ENTITY_KEY,
      // A getter, so the title is translated when it is read, not when this module loads.
      get title() {
        return i18n.t("create_model_provider_page.title", { ns: "enterprise_ai" });
      },
      path: AIManagementRoutes.MODEL_PROVIDER_CREATE,
      permissions: "llm_provider:edit",
      requiredFeatureFlag: AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG,
      telemetryEvent: {
        type: TELEMETRY_EVENT_TYPE.AI_MANAGEMENT.MODEL_PROVIDER_CREATE_CLICKED,
        section: "ai-management-model-providers",
        actionValue: "create-model-provider-button"
      }
    }
  ],
  navigation: [
    {
      description: SYSTEM_DROPDOWN_TITLE,
      titleKey: "navigation:main.system",
      children: [
        {
          path: AIManagementRoutes.MODEL_PROVIDERS,
          description: PAGE_NAVIGATION_TITLE,
          position: { after: AUTHENTICATION_LINK_TITLE },
          titleKey: "enterprise_navigation:system.ai_management",
          permissions: ["llm_provider:edit"],
          requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG,
          useCondition: useAgentWorkflowsLicensed
        }
      ]
    }
  ],
  pageNavigation: [
    {
      description: PAGE_NAVIGATION_TITLE,
      children: [
        {
          description: MODEL_PROVIDER_TITLE,
          titleKey: "enterprise_navigation:ai_management.model_provider",
          path: AIManagementRoutes.MODEL_PROVIDERS,
          permissions: ["llm_provider:edit"],
          requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG,
          useCondition: useAgentWorkflowsLicensed
        },
        {
          description: TOKEN_USAGE_TITLE,
          titleKey: "enterprise_navigation:ai_management.token_usage",
          path: AIManagementRoutes.TOKEN_USAGE,
          permissions: ["llm_provider:edit"],
          requiredFeatureFlag: AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG,
          useCondition: useAgentWorkflowsLicensed
        },
        {
          description: FEATURE_MODELS_TITLE,
          path: AIManagementRoutes.FEATURE_MODELS,
          permissions: ["llm_provider:edit"],
          requiredFeatureFlag: AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG,
          useCondition: useAgentWorkflowsLicensed
        }
      ]
    }
  ]
};
export default pluginExports;
